<template>
  <div class="organization-layout">
    <div class="organization-page-title-container">
      <PageTitle title="Organization" />
    </div>
    <OrganizationHorizontalMenu
      :menuItems="menuItems"
      :initialTab="currentTab"
      :count_of_active_employees="sidebarCountStore.employees"
      :count_of_active_positions="sidebarCountStore.positions"
      :count_of_active_roles="sidebarCountStore.roles"
      :count_of_active_responsibilities="sidebarCountStore.responsibilities"
      @tab-selected="handleTabChange"
    />
    <div class="layout-content">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router/composables';
import OrganizationHorizontalMenu from '@components/OrganizationHorizontalMenu/OrganizationHorizontalMenu.vue';
import PageTitle from '@components/common/PageTitle.vue';
import { useSidebarCountStore } from '@/store/pinia/sidebarCount';
import Home from '@components/assets/icons/Home.svg';
import Employee from '@components/assets/icons/Employee.svg';
import Position from '@components/assets/icons/Position.svg';
import Role from '@components/assets/icons/Role.svg';
import Responsibility from '@components/assets/icons/Responsibility.svg';

const instance = getCurrentInstance();
const router = instance?.proxy?.$router || useRouter();
const sidebarCountStore = useSidebarCountStore();

const currentTab = computed(() => {
  const path = router?.currentRoute?.path || '';
  const routeName = router?.currentRoute?.name || '';
  
  // Check for position detail routes (including nested role and responsibility)
  if (path.includes('/positions') || 
      routeName === 'PositionDetail' || 
      routeName === 'PositionDetailChild' ||
      routeName === 'RoleDetailFromPosition' ||
      routeName === 'ResponsibilityDetailFromPositionRole' ||
      routeName === 'ResponsibilityDetailFromPositionRoleChild') {
    return 'Positions';
  }
  
  // Check for role detail routes (from roles list)
  if (routeName === 'ResponsibilityDetailFromRole' || 
      routeName === 'ResponsibilityDetailFromRoleChild') {
    return 'Roles'; // Responsibility accessed from role (not from position)
  }
  if (path.includes('/roles') || routeName === 'RoleDetail' || routeName === 'RoleDetailChild') {
    return 'Roles'; // Role accessed from roles list
  }
  
  if (path.includes('/responsibilities') || routeName === 'ResponsibilityDetail' || routeName === 'ResponsibilityDetailChild') return 'Responsibilities';
  if (path.includes('/employees')) return 'Employees';
  return 'Dashboard';
});

const menuItems = computed(() => [
  { label: 'Dashboard', icon: Home },
  { label: 'Employees', icon: Employee },
  { label: 'Positions', icon: Position },
  { label: 'Roles', icon: Role },
  { label: 'Responsibilities', icon: Responsibility },
]);

const handleTabChange = (tabLabel) => {
  const routes = {
    'Dashboard': '/new-organization/dashboard',
    'Employees': '/new-organization/employees',
    'Positions': '/new-organization/positions',
    'Roles': '/new-organization/roles',
    'Responsibilities': '/new-organization/responsibilities'
  };
  
  if (router && routes[tabLabel]) {
    router.push(routes[tabLabel]).catch(() => {});
  }
};
</script>

<style scoped>
.organization-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
}

.layout-content {
  flex: 1;
  width: 100%;
  margin-top: 12px;
}

.organization-page-title-container {
  padding: 24px 0px 0px 0px;
}
</style>
